/**
 * Minified by jsDelivr using Terser v5.19.2.
 * Original file: /npm/vue-demi@0.14.7/lib/index.iife.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
